export default __webpack_public_path__ + "static/media/line-v-16.fcc71c67.png";